/* eslint-disable eqeqeq */
// 身份证 | NID(18位二代身份证)
export const nidCheck = (num) => {
  // 检验省份（身份证前6位分别代表省级行政区、地级行政区、县级行政区）
  const checkProvince = (id) => {
    const temp = id.substring(0, 2);
    const pattern = /^[1-9][0-9]/;
    const province = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江 ',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北 ',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏 ',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外',
    };
    if (pattern.test(temp)) {
      if (province[temp]) {
        return true;
      }
    }
    return false;
  };

  // 出生日期校验
  const checkDate = (id) => {
    const temp = id.substring(6, 14);
    const pattern = /^\d{4}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
    if (pattern.test(temp)) {
      const year = temp.substring(0, 4);
      const month = temp.substring(4, 6);
      const date = temp.substring(6, 8);
      const date2 = new Date(`${year}-${month}-${date}`);
      // eslint-disable-next-line eqeqeq
      if (date2 && date2.getMonth() == parseInt(month, 10) - 1) {
        return true;
      }
    }
    return false;
  };

  // 校验校验码（最后一位）
  const checkCode = (id) => {
    const code = id.substring(17);
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += id[i] * factor[i];
    }
    // eslint-disable-next-line eqeqeq
    if (parity[sum % 11] == code.toUpperCase()) {
      return true;
    }
    return false;
  };

  const pattern = /^[1-9]\d{9}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  if (pattern.test(num) && checkProvince(num) && checkDate(num) && checkCode(num)) return true;
  return false;
};

// 15位身份证号 | OLDNID
export const oldnidCheck = (num) => {
  // 检验省份（身份证前6位分别代表省级行政区、地级行政区、县级行政区）
  const checkProvince = (id) => {
    const temp = id.substring(0, 2);
    const pattern = /^[1-9][0-9]/;
    const province = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江 ',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北 ',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏 ',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外',
    };
    if (pattern.test(temp)) {
      if (province[temp]) {
        return true;
      }
    }
    return false;
  };

  // 出生日期校验
  const checkDate = (id) => {
    const temp = id.substring(6, 12);
    const pattern = /^\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
    if (pattern.test(temp)) {
      const year = '19'.concat(temp.substring(0, 2));
      const month = temp.substring(2, 4);
      const date = temp.substring(4, 6);
      const date2 = new Date(`${year}-${month}-${date}`);
      if (date2 && date2.getMonth() == parseInt(month, 10) - 1) {
        return true;
      }
    }
    return false;
  };

  const pattern = /^[1-9]\d{7}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}$/;
  if (pattern.test(num) && checkProvince(num) && checkDate(num)) return true;
  return false;
};

// 港澳通行证 | HK/MA
export const hkmaCheck = (id) => {
  const reg = /^[H|h|M|m]\d{8}$/;
  if (reg.test(id)) return true;
  return false;
};

// 回乡证（台湾） | HXZ
export const hxzCheck = (id) => {
  const reg = /^\d{8}$/;
  if (reg.test(id)) return true;
  return false;
};

// 军官证 | MILID
export const milidCheck = (id) => {
  // 规则： 军/兵/士/文/职/广/（其他中文） + "字第" + 4到8位字母或数字 + "号"
  // 样本： 军字第2001988号, 士字第P011816X号
  const reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号)$/;
  if (reg.test(id)) return true;
  return false;
};

// 台湾身份证 | TWNID
export const twnidCheck = (id) => {
  if (/^[a-zA-Z][1-2]\d{8}$/.test(id)) {
    const area = {
      A: 10,
      B: 11,
      C: 12,
      D: 13,
      E: 14,
      F: 15,
      G: 16,
      H: 17,
      J: 18,
      K: 19,
      L: 20,
      M: 21,
      N: 22,
      P: 23,
      Q: 24,
      R: 25,
      S: 26,
      T: 27,
      U: 28,
      V: 29,
      X: 30,
      Y: 31,
      W: 32,
      Z: 33,
      I: 34,
      O: 35,
    };
    const sum =
      parseInt((area[id[0].toUpperCase()] / 10).toString(), 10) +
      9 * (area[id[0].toUpperCase()] % 10) +
      8 * id[1] +
      7 * id[2] +
      6 * id[3] +
      5 * id[4] +
      4 * id[5] +
      3 * id[6] +
      2 * id[7] +
      Number(id[8]);

    if (id[9] == 10 - (sum % 10)) {
      return true;
    }
  }

  return false;
};

export const cardChecking = (value, idTypeCode, callback) => {
  if (idTypeCode === 'NID' && value.length !== 18) {
    callback('证件号码有误，请检查');
  } else if (idTypeCode === 'OLDNID' && !oldnidCheck(value)) {
    callback('证件号码有误，请检查');
  } else if (idTypeCode === 'HK/MA' && !hkmaCheck(value)) {
    callback('证件号码有误，请检查');
  } else if (idTypeCode === 'HXZ' && !hxzCheck(value)) {
    callback('证件号码有误，请检查');
  } else if (idTypeCode === 'MILID' && !milidCheck(value)) {
    callback('证件号码有误，请检查');
  } else if (idTypeCode === 'TWNID' && !twnidCheck(value)) {
    callback('证件号码有误，请检查');
  }
};
